module.exports = __webpack_public_path__ + "e.no1.ad0cd437.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e.no1.jpg
// module id = xsJv
// module chunks = 0